import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { getEntityUrl } from '@culture/common-helpers/cultureUtils';
import { statusesHash } from '@culture/utils/helpers/statuses';

import styles from './styles.module.scss';

const wordVariantsHash = {
	actor: {
		single: 'В ролях',
		many: 'В ролях'
	},
	director: {
		single: 'Режиссер',
		many: 'Режиссеры'
	},
	lecturer: { single: 'Лектор', many: 'Лекторы' },
	writer: { single: 'Писатель', many: 'Писатели' }
};

const Participants = ({ data, movieType }) => {
	const participants = _(data)
		.chain()
		.groupBy(({ type }) => type.name)
		.mapObject((array) =>
			array.map(({ person }) => ({
				title: person.title,
				url:
					person.status === statusesHash.published
						? getEntityUrl('persons', person)
						: null
			}))
		)
		.value();

	return (
		<div className={styles.block}>
			{_.map(participants, (persons, type) => {
				const wordVariants = wordVariantsHash[type];
				const showOthersActors =
					['movie', 'performance'].includes(movieType) && type === 'actor';

				if (wordVariants) {
					const subTitle =
						persons.length > 1 ? wordVariants.many : wordVariants.single;

					return (
						<div key={subTitle} className={styles.row}>
							<span className={styles.subTitle}>{subTitle}:</span>{' '}
							{persons.map(({ title, url }, index) => (
								<React.Fragment key={title}>
									{url ? (
										<a href={url} className={styles.link}>
											{title}
										</a>
									) : (
										title
									)}
									{index !== persons.length - 1 ? ', ' : ''}
								</React.Fragment>
							))}
							{showOthersActors && <span> и другие</span>}
						</div>
					);
				}

				return null;
			})}
		</div>
	);
};

Participants.propTypes = {
	data: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.shape({
				name: PropTypes.string.isRequired
			}).isRequired,
			person: PropTypes.shape({
				name: PropTypes.string.isRequired,
				title: PropTypes.string.isRequired,
				_id: PropTypes.number.isRequired,
				status: PropTypes.oneOf(Object.keys(statusesHash)).isRequired
			}).isRequired
		})
	).isRequired,
	movieType: PropTypes.string
};

export default Participants;
